var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column-layout" }, [
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c("swb-query-sort-area", {
          ref: "query_model",
          attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
        }),
        _vm._v(" "),
        !_vm.readFlag
          ? _c("div", { staticClass: "mt5" }, [
              _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-mini mb10 fr",
                  on: {
                    click: function($event) {
                      _vm.markMsgGroupAsRead()
                    }
                  }
                },
                [_vm._v("全部已读")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-mini mr10 fr",
                  on: {
                    click: function($event) {
                      _vm.getXMsgList()
                    }
                  }
                },
                [_vm._v("刷新")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.xMsgList,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    width: "180",
                    label: "单据号",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _vm.showSkipVoucher(rows.row)
                            ? _c(
                                "span",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toVoucherInfo(
                                        rows.row.fieldx,
                                        rows.row.fieldy,
                                        rows.row.data
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.fieldy))]
                              )
                            : rows.row.group == "voucher"
                            ? _c("span", [_vm._v(_vm._s(rows.row.fieldy))])
                            : _c("span", [_vm._v("无")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    width: "220",
                    label: "标题",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.url != null && rows.row.type == 0
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.toContractList(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.txt))]
                              )
                            : _c("span", [_vm._v(_vm._s(rows.row.txt))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "内容", "show-overflow-tooltip": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.data != null &&
                          rows.row.data.indexOf("{") >= 0
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(JSON.decode(rows.row.data).message)
                                )
                              ])
                            : _c("span", [_vm._v(_vm._s(rows.row.data))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "图片", align: "center", width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.url != null
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.showImg(rows.row.url)
                                    }
                                  }
                                },
                                [_c("img", { attrs: { src: rows.row.url } })]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "senderName",
                    label: "发信者",
                    width: "220",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "sendTime",
                    width: "180",
                    label: "发送时间",
                    align: "center",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(rows.row.sendTime.replace(".000", ""))
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "caozuo",
                    width: "80",
                    align: "center",
                    label: "操作"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.data != null &&
                          rows.row.data.indexOf("{") >= 0
                            ? _c("div", [
                                !rows.row.notShowView
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.msgInfo(rows.row)
                                          }
                                        }
                                      },
                                      [_vm._v("查看")]
                                    )
                                  : _vm._e()
                              ])
                            : _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.msgInfo(rows.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block pagination-layout" },
      [
        _c("el-pagination", {
          staticClass: "mt10",
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "total, sizes, prev, pager, next, jumper"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-845faaba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-845faaba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/msg/ReceiverMsgList.vue
// module id = 3298
// module chunks = 0